import { render, staticRenderFns } from "./LeftBox3.vue?vue&type=template&id=0909fee4&scoped=true"
import script from "./LeftBox3.vue?vue&type=script&lang=js"
export * from "./LeftBox3.vue?vue&type=script&lang=js"
import style0 from "./LeftBox3.vue?vue&type=style&index=0&id=0909fee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909fee4",
  null
  
)

export default component.exports